import { createModelSegment } from 'client/data/luckdragon/segment';

export const URL_CONTEXT_PATH = 'context';

export const UrlModel = createModelSegment('url', []);
